import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/apps/web/app/(marketing)/tools/openai-token-counter/page-client.tsx");
